import { useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import styles from "../../assets/css/forms.module.css";
import defaultProfile from "../../../assets/images/testimage1.png";
import { useFormik } from "formik";
import * as yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import { postData1 } from "../../../services";
import {
  emailSchema,
  fnameSchema,
  gstinSchema,
  lnameSchema,
  mnumberSchema,
  nationalitySchema,
  pancardSchema,
} from "../../../utils/validation";
import PersonalContactDetails from "../Dashboard/PersonalContactDetails";
import DashboardDetails from "../Dashboard/DashboardDetails";
import BusinessContactDetails from "../Dashboard/BusinessContactDetails";
import ProductActivitySection from "../Dashboard/ProductActivitySection";
import AdminActions from "../Dashboard/AdminActions";

export const UserFrom = () => {
  const [formDisabled, setFormDisabled] = useState(true);
  const { uid } = useParams();
  const [userData, setUserData] = useState({});
  const [userStatus, setUserStatus] = useState(0);
  // const [userStatus, setUserStatus] = useState(userData?.status);
  const [perm, updatePerm] = useState(true);

  const formik = useFormik({
    initialValues: {
      fname: userData?.profile?.first_name,
      phone: userData?.mobile,
      nationality: userData?.profile?.location,
      gstin: userData?.profile?.gstin,
      lname: userData?.profile?.last_name,
      email: userData?.email,
      pancard: userData?.profile?.pan_no,
      profile_type: userData?.profile?.profile_type,
      organization_name: userData?.profile?.organization_name,
      mci_registration_number: userData?.profile?.mci_registration_number,
    },
    // validationSchema: yup.object().shape({
    //     fname  : fnameSchema,
    //     lname : lnameSchema,
    //     pnumber : mnumberSchema,
    //     email : emailSchema,
    //     gstin : gstinSchema,
    //     pancard : pancardSchema,
    //     nationality : nationalitySchema
    // }),
    onSubmit: function (values) {
      // handleSubmit(values);
    },
  });

  useEffect(() => {
    getUserDetails();
  }, [uid]);

  const getUserDetails = async () => {
    const res = await postData1("admin/user_details/",
      {
        uid: uid,
      },
      true,
      true
    );
    if (res?.status_code === 200) {
      setUserData(res?.data);
      setUserStatus(res?.data?.status);
    }
  };

  const handlePermission = async () => {
    let body = { uid: userData?.uid, status: userData?.status ? 0 : 1 };
    const res = await postData1("admin/update_user_status/", body, true, true);
    if (res?.status_code === 200) {
      updatePerm(true);
      setUserStatus(body.status);
      toast.success("Permission updation successful");
    } else {
      toast.warning("Something Went Wrong, Try Again !");
    }
  };
   

  console.log(userData);

  return (
    <section >
      <ToastContainer />
      {/* <h2>Detail Info <i onClick={()=>setFormDisabled(!formDisabled)} className="bi bi-pencil-square"></i> </h2> */}
      <PersonalContactDetails
        userData={userData}
        getUserDetails={getUserDetails}
      />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">

        {/* Left 50% */}
        <DashboardDetails
          userData={userData}
        />

        {/* Right 50% */}
        <BusinessContactDetails
          userData={userData}
          getUserDetails={getUserDetails}
        />

      </div>
      <div className="mt-4">
      <AdminActions
        userData={userData}
      />
      </div>
      <ProductActivitySection
        userData={userData}
      />
    </section>
  );
};
